import { render, staticRenderFns } from "./lockscreen-2.vue?vue&type=template&id=1cfe7a3a&scoped=true&"
import script from "./lockscreen-2.vue?vue&type=script&lang=js&"
export * from "./lockscreen-2.vue?vue&type=script&lang=js&"
import style0 from "./lockscreen-2.vue?vue&type=style&index=0&id=1cfe7a3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cfe7a3a",
  null
  
)

export default component.exports